import { render, staticRenderFns } from "./components-display.vue?vue&type=template&id=1c76779c&scoped=true&"
import script from "./components-display.js?vue&type=script&lang=js&"
export * from "./components-display.js?vue&type=script&lang=js&"
import style0 from "./components-display.scss?vue&type=style&index=0&id=1c76779c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c76779c",
  null
  
)

component.options.__file = "components-display.vue"
export default component.exports